export interface RoomLayoutEligibleDocEntity {
  readonly entityInstanceType?: EntityInstanceType; // undefined indicates entity is not participating in a room layout
}

export enum EntityInstanceType {
  ROOM_LAYOUT_SOURCE = "ROOM_LAYOUT_SOURCE",
  ROOM_LAYOUT_INSTANCE = "ROOM_LAYOUT_INSTANCE",
  COMPONENT_INSTANCE = "COMPONENT_INSTANCE",
}
